import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';

//Services
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/core/services/auth.service';
import { InvoiceService } from '../../../../core/services/invoice.service';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import { ValidadoresService } from 'src/app/core/services/validadores.service';


@Component({
  selector: 'app-preview-docs-user-list',
  templateUrl: './preview-docs-user-list.component.html',
  styleUrls: ['./preview-docs-user-list.component.scss']
})
export class PreviewDocsUserListComponent implements OnInit {

  currentUser: User;
  filtro: FormGroup;
  valorPrinSec: string = '';
  loading: boolean;
  mostrarListado: boolean;
  mostrarError: boolean;
  totalRecibidas: number;
  totalEmitidas: number;

  datos = []; //Para listado de documentos pendientes

  constructor(
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private authService: AuthService,
    private invoiceServices: InvoiceService,
    private toastr: ToastrService,
    private validadores: ValidadoresService,
  ) {
    this.loading = false;
    this.mostrarListado = false;
    this.mostrarError = false;
    this.totalEmitidas = 0;
    this.totalRecibidas = 0;
    this.currentUser = this.authService.currentUserValue;

    this.filtro = this.fb.group({
      usuario: [''],
      fechaInit: ['', [this.validadores.fechaNoAdecuada]],
      fechaFin: ['', [this.validadores.fechaNoAdecuada]]
    });

    if (this.currentUser.facturasCliente != null && this.currentUser.facturasCliente != "" && this.currentUser.facturasCliente != " ") {

      var value = this.currentUser.facturasCliente;
      this.valorPrinSec = value;

      this.filtro.patchValue({
        usuario: value
      });
      this.filtro.get("usuario").disable();
    }

    const navigation = this.router.getCurrentNavigation();
    console.warn(navigation);

    if (navigation != null && navigation.extras != null) {

      const state = navigation.extras.state as {
        ///////filtro
        usuarioFiltro: string
        fechaIni: string,
        fechaFin: string
      };
      if (state != undefined) {
        if (state.usuarioFiltro != "" && state.usuarioFiltro != null && state.usuarioFiltro != undefined) {
          this.filtro.patchValue({
            usuario: state.usuarioFiltro
          });
        }
        if (state.fechaIni != "" && state.fechaIni != null && state.fechaIni != undefined) {
          this.filtro.patchValue({
            fechaInit: state.fechaIni
          });
        }
        if (state.fechaFin != "" && state.fechaFin != null && state.fechaFin != undefined) {
          this.filtro.patchValue({
            fechaFin: state.fechaFin
          });
        }
      }
    }
  }

  ngOnInit() {
    this.VisualizarDocumentosPendientes(this.filtro.get('usuario').value, this.filtro.get("fechaInit").value, this.filtro.get("fechaFin").value);
  }

  VisualizarDocumentosPendientes(usuario: string, fechaInicial: string, fechaFinal: string) {

    //SE COMPROBARA SI EL INVOICER ESTA EN MANTENIMIENTO.
    //Si es asi, se forzara un cierre de sesion antes de cargar un documento.
    this.authService.ObtenerEstadoMantenimiento().subscribe(enMantenimiento => {

      if (enMantenimiento == true) {
        //Se cierra sesion...

        const userId: string = this.authService.currentUserValue.email;

        this.authService.QuitarDocumentosAsignados(userId).subscribe(quitado => {
          this.authService.Logout();
          this.toastr.info("El Invoicer esta en mantenimiento. Espere un momento a que vuelva a estar habilitado.");
          this.router.navigate(['/Login']);
        }, error => {
          console.log(error);
        });

      } else {

        this.loading = true;
        this.mostrarListado = false;
        this.mostrarError = false;
        let inicial: number = this.GetFechaInteger(fechaInicial);
        let final: number = this.GetFechaInteger(fechaFinal);

        this.datos = [];

        this.invoiceServices.ObtenerListadoDocumentosPendientes(usuario, inicial, final).subscribe(datos => {
          this.datos = datos;
          console.warn("Documentos pendientes de revision: ");
          console.warn(this.datos);

          this.totalEmitidas = this.datos.map(a => Number(a.totalEmitidas)).reduce((a, b) => a + b, 0);
          this.totalRecibidas = this.datos.map(a => Number(a.totalRecibidas)).reduce((acumulator, current) => acumulator + current, 0);

          this.loading = false;
          this.mostrarListado = true;

          //Carga paralela de nombres principal y secundario:
          // this.datos.forEach(element => {

          //   this.invoiceServices.ObtenerNombresPrincSec(element.principal, element.secundario)
          //     .subscribe(resultado => {

          //       element.nombrePrincipal = resultado.nombrePrin;
          //       element.nombreSecundario = resultado.nombreSecun;

          //     }, error => {
          //       console.log(error);
          //     });
          // });

        }, (error) => {

          console.warn("Error en la caga del listado de pendientes de revisión.");
          console.log(error);
          this.loading = false;
          this.mostrarError = true;
        });
      }

    }, error => {
      console.log(error);
    });
  }

  cargarDetalleDocs(datos: any) {



    const navigationExtras: NavigationExtras = {
      state: {
        principal: datos.principal,
        nombrePrincipal: datos.nombrePrincipal,
        secundario: datos.secundario,
        nombreSecundario: datos.nombreSecundario,
        totalRecibidas: datos.totalRecibidas,
        totalEmitidas: datos.totalEmitidas,
        total: datos.total,
        fechaDocumento: datos.fechaDocumento,
        horaDocumento: datos.horaDocumento,
        //////filtros
        usuarioFiltro: this.filtro.get('usuario').value,
        fechaIni: this.filtro.get("fechaInit").value,
        fechaFin: this.filtro.get("fechaFin").value
      }
    };

    this.router.navigate(['/Preview', datos.secundario], navigationExtras);
  }

  pasarDocumentosAestadoComprobacion(objeto: any) {
    this.cargarDetalleDocs(objeto);
  }

  convertThousandsFixed(number: any, digits) {
    if (typeof number === "undefined") {
      number = 0.0;
    }

    if (this.isDecimal(number) === true) {
      number = parseFloat((Math.round(number * 100) / 100).toString()).toFixed(
        2
      );

      number = number.toString().replace(".", ",");
    }

    var value = number.toString().split(".").join("");

    var numbers = value.split(",");
    var enter = numbers[0];
    var new_number = "";

    var amount = enter.toString();
    amount = amount.split("").reverse();

    var output = "";

    for (var i = 0; i <= amount.length - 1; i++) {
      output = amount[i] + output;
      if ((i + 1) % 3 === 0 && amount.length - 1 !== i) output = "." + output;
    }

    if (digits !== "0") {
      if (numbers.length === 1) {
        if (numbers[0] === "") {
          new_number = output;
        } else {
          new_number = output + ",00";
        }
      } else {
        if (numbers[1] === "") {
          new_number = output + ",00";
        } else {
          if (numbers[1].substring(0, 2).length === 1) {
            new_number = output + "," + numbers[1].substring(0, 1) + "0";
          } else {
            new_number = output + "," + numbers[1].substring(0, digits);
          }
        }
      }
      if (
        new_number.substring(0, 1) === "-" &&
        new_number.substring(1, 2) === "."
      ) {
        new_number = new_number.replace(".", "");
      }
      if (new_number === "0,0000") {
        new_number = "0,00";
      }
    } else {
      new_number = output;
      if (numbers[1] !== undefined) {
        new_number = new_number + "," + numbers[1];
      }
    }

    if (digits === "0") {
      numbers = new_number.split(",");
      if (Number(numbers[1]) === 0) {
        new_number = numbers[0];
      }
    }

    return new_number;
  }

  private isDecimal(number) {
    if (typeof number === "undefined") {
      return false;
    } else {
      number = Math.abs(number);
    }

    var pattern = /^\d+(\.\d*)?$/;
    if (pattern.test(number)) {
      return true;
    } else {
      return false;
    }
  }

  private isNumber(numero) {
    if (this.isDecimal(numero) || !isNaN(parseInt(numero))) {
      return true;
    }
    return false;
  }

  fechaChange($event, esFecha: number) {

    let fechaall: string = "";

    if (typeof ($event) === "string") {
      fechaall = $event;
    } else if (typeof ($event) === "number") {
      fechaall = $event.toString();
    } else if ($event.target != undefined && $event.target != null) {
      fechaall = $event.target.value;
    }

    let format = 'dd/mm/yy';

    let resultado = "";
    let fecha = "";

    if (fechaall.length == 10) {
      while (fechaall.indexOf("/") > -1) {
        fechaall = fechaall.replace("/", "");
      }
    }

    let diasMes = fechaall.substring(0, 2);
    let mesFecha = fechaall.substring(2, 4);

    if (fechaall) {
      if (fechaall.length > 8 || fechaall.length < 4 || fechaall.length == 7 || fechaall.length == 5) {

        this.toastr.error("Fecha incorrecta.");

      } else if (parseInt(diasMes) > 31 || parseInt(diasMes) < 1) {

        this.toastr.error("Fecha incorrecta.");

      } else if (parseInt(mesFecha) > 12 || parseInt(mesFecha) < 1) {

        this.toastr.error("Fecha incorrecta.");

      } else {

        if (fechaall.indexOf('/') >= 0 && fechaall != "") {

          let fechaArray = fechaall.split('/');

          let dia = fechaArray[0];
          dia = dia.length < 2 ? "0" + (dia) : dia;

          let mes = fechaArray[1];
          mes = mes.length < 2 ? "0" + (mes) : mes;

          let hoy = new Date;

          let anio = fechaArray[2];

          if (anio) {
            switch (anio.length) {
              case 4:
                anio = anio; break;
              case 2:
                anio = "20" + anio; break;
              default:
                anio = '';
            }

          } else { anio = hoy.getFullYear().toString(); }

          if (dia != '' && mes != '' && anio != '') {
            fecha = dia + mes + anio;
          }

        } else {
          fecha = fechaall;
        }

        if (this.isNumber(fecha)) {

          if (format === 'dd/mm') {

            switch (fecha.length) {
              case 8:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4);// + "/" + fecha.substring(4, 8);
                break;
              case 6:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4);// + "/" + anio;
                break;
              case 4:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4);// + "/" + new Date().getFullYear();
                break;
              default:
                resultado = fecha;
            }

          }
          else {

            switch (fecha.length) {
              case 8:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4) + "/" + fecha.substring(4, 8);
                break;
              case 6:
                var anio = fecha.substring(4, 6);

                if (parseInt(anio.substring(0, 1)) <= 9 && parseInt(anio.substring(0, 1)) >= 5) {
                  anio = "19" + anio;
                } else {
                  anio = "20" + anio;
                }
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4) + "/" + anio;
                break;
              case 4:
                resultado = fecha.substring(0, 2) + "/" + fecha.substring(2, 4) + "/" + new Date().getFullYear();
                break;
              default:
                resultado = fecha;
            }

            moment.locale("es");
            var fechaValidacion = moment().format(resultado);

            if (!moment(fechaValidacion, 'DD-MM-YYYY').isValid()) {

              this.toastr.error('Fecha incorrecta.');

              resultado = "";

            } else {

              resultado = fechaValidacion;
            }
          }
        } else {
          this.toastr.error('Fecha incorrecta.');
          resultado = "";
        }

      }
    }

    if (esFecha == 1) {

      this.filtro.patchValue({
        fechaInit: resultado
      });
    }
    if (esFecha == 2) {

      this.filtro.patchValue({
        fechaFin: resultado
      });
    }
  }

  private GetFechaInteger(date: string): number {
    if (date == "" || date == undefined) {
      return 0;
    }

    if (date.length != 10) {
      return 0;
    }

    let dia = Number(date.substr(0, 2));
    let mes = Number(date.substr(3, 2));
    let ano = Number(date.substr(6, 4));

    if (Number.isNaN(dia) == true || dia == undefined || Number.isNaN(mes) == true || mes == undefined || Number.isNaN(ano) == true || ano == undefined) {
      return 0;
    }

    return ano * 10000 + mes * 100 + dia;
  }

}
